function LoaderSpin({
  show = true,
  width = 5,
  height = 5,
  wrapperClass = 'bg-white',
  spinClass = 'border-t-primary'
}) {
  return (
    show && <div className={`fit z-20 flex-center ${wrapperClass}`}>
      <div className={`relative w-${width} h-${height}`}>
        <div className={`rounded-full animate-spin fit border-2 border-grey-100 ${spinClass}`}></div>
      </div>
    </div>
  )
}

export default LoaderSpin
